import {
  createPlugin,
  createRoutableExtension,
} from "@backstage/core-plugin-api";

import { explorerRouteRef } from "./routes";

export const cloudhealthExplorerPlugin = createPlugin({
  id: "cloudhealth-explorer",
  routes: {
    root: explorerRouteRef,
  },
});

export const CloudHealthExplorerPage = cloudhealthExplorerPlugin.provide(
  createRoutableExtension({
    name: "CloudHealthExplorerPage",
    mountPoint: explorerRouteRef,
    component: () =>
      import("./components/AssetExplorerPage").then((m) => m.AssetExplorerPage),
  }),
);
